@if (shop$ | async; as shop) {
  @if (shop.available) {
    @if (filters$ | async; as filters) {
      <div>
        <app-horizontal-filter-list-atom
          [items]="filters"
          (clickItem)="onClickFilter($event)"
        ></app-horizontal-filter-list-atom>
      </div>
    }
  }
}
